import styled from "styled-components";

export const Paragraph = styled.p`
	// margin-top : 83px;
	color: #000000;
	font-family: Montserrat;
	size: 16px;
`;
